import React from "react";
import { connect } from 'react-redux';
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from 'react-router-dom';
import { getPendingApprovalsList } from '../Actions/ApproverScreenAPI'

let user = JSON.parse(localStorage.getItem("currentUser"));
class PendingApproval extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  
        }
    }
    
    componentDidMount() {
        this.props.dispatch(getPendingApprovalsList(user));
        this.props.dispatch({ type: "SubBannerTitle", data: "Pending Approvals" });
    }

    showEquipments = (id) => {
        const { history,dispatch } = this.props;
        dispatch({ type: "ShowSidePan", data: false });
        history.push(`/Home/PendingApprovals/${id}/Equipments`);
    }

    hideSidePanel() {
        const { dispatch, history } = this.props;
        dispatch({ type: "ShowSidePan", data: false });
        history.goBack();
    }

    render() {
        const { PendingApprovals,t } = this.props;
        return (
            <div className="pb-3">
                <div className="full-height">
                    <div className="resource-list-auth-date col-lg-12 row pt-3 ">
                        <div className='col-lg-12  search-filter-box'>
                            <div className="panel-box ml-4">
                                <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                        <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>{t("PendingApprovalScreenContent.Title")}</h5>
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    {PendingApprovals && PendingApprovals.length ? PendingApprovals.map((item, index) => {
                                        if (!item.isDeleted) {
                                            return (
                                                <div className="card m-3" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                                                    <div className="p-3" >
                                                        <div className="resource-list-auth-date">
                                                            <div className="row">
                                                                <div className="col-sm-8 col-md-11 col-8 m-auto">
                                                                    <div className="row">
                                                                        <div className="col-sm-5">
                                                                            <span className="resource-list-title m-0">
                                                                                {item.shipName}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-sm-5 mt-2">
                                                                            <span><strong>{t("PendingApprovalScreenContent.NoofEquipments")} : </strong>
                                                                                <span className="italicFont ">{item.noOfEquipment}</span>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-4 col-md-1 col-4 m-auto">
                                                                    <div className="text-center">
                                                                        <i className="fa fa-eye fa-2x click ml-1"
                                                                            style={{ marginLeft: '-15px' }}
                                                                            onClick={() => this.showEquipments(item.shipId)}
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                        :
                                        <div className="card m-3" style={{ overflow: "hidden", position: "relative" }}>
                                            <div className="container">
                                                <h6 className="resource-list-title no-item-card">
                                                {t("PendingApprovalScreenContent.NoPending")}
                                                </h6>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        PendingApprovals: state.ApproverScreenReducer.PendingApprovals || [],
    }
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(PendingApproval)));